/**
 * STADICHAIR – Custom JS Enhancements
 * Datei: assets/stadichair-custom.js
 * Einbinden in layout/theme.liquid vor </body>:
 *   <script src="{{ 'stadichair-custom.js' | asset_url }}" defer></script>
 *
 * LETZTE ÄNDERUNG: 2026-06-12
 * INHALT:
 *   1. ATC-Button zeigt gewählte Variante
 *   2. Post-ATC Feedback: Button zeigt "✓ Hinzugefügt"
 *
 * ENTFERNT (2026-06-12): MutationObserver/forceSticky –
 * Sticky ATC wird jetzt allein über custom.css Block [2]
 * erzwungen. Weniger Main-Thread-Last → besserer INP.
 */

document.addEventListener('DOMContentLoaded', function () {

  // ────────────────────────────────────────────────
  // 1. ATC-Button zeigt gewählte Variante
  // ────────────────────────────────────────────────
  function updateATCButtonLabel(form) {
    const btn = form.querySelector('.product-form__submit');
    if (!btn) return;

    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent.trim();
    }

    const selected = Array.from(
      form.querySelectorAll(
        '.variant-picker__option-value--selected, ' +
        'input[type="radio"]:checked + label, ' +
        '.swatch--active'
      )
    )
      .map(el => el.textContent.trim())
      .filter(Boolean);

    if (selected.length) {
      btn.textContent = 'In den Warenkorb – ' + selected.join(' / ');
    } else {
      btn.textContent = btn.dataset.originalText;
    }
  }

  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    updateATCButtonLabel(form);
    form.addEventListener('change', function () {
      updateATCButtonLabel(form);
    });
  });


  // ────────────────────────────────────────────────
  // 2. Post-ATC Feedback: Button zeigt "✓ Hinzugefügt"
  // ────────────────────────────────────────────────
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      const btn = form.querySelector('.product-form__submit');
      if (!btn) return;

      const originalText = btn.dataset.originalText || btn.textContent.trim();
      const originalBg   = btn.style.backgroundColor;

      btn.textContent = '✓ Hinzugefügt';
      btn.disabled = true;
      btn.style.backgroundColor = '#2d7a2d';

      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.style.backgroundColor = originalBg;
      }, 2200);
    });
  });

});